import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { fetchQuestions } from '../questions-database/questions-database.actions';

import SelectionQuestionPresentation from './selection-questions-presentation';

class SelectionQuestions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            questionsAddeds: [],
            questions: [],
            total: 0,
            limit: 25,
            page: 0,
        };
    }

    componentDidMount() {
        const { limit, page } = this.state;
        const { questionsAlreadySelecteds, total } = this.props;
        this.fetchQuestionsToRender({ limit, page });
        this.setState({ total });
        if (questionsAlreadySelecteds) {
            this.setState({ questionsAddeds: questionsAlreadySelecteds });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { page, limit, questionsAddeds } = this.state;
        const { questions, total, onChangeSelecteds } = this.props;

        if (prevState.questionsAddeds !== questionsAddeds) {
            if (onChangeSelecteds) {
                onChangeSelecteds(questionsAddeds);
            }
        }

        if (prevProps.questions !== questions) {
            this.setState({
                questions: questions,
            });
        }

        if (prevProps.total !== total) {
            this.setState({
                total: total,
            });
        }

        if (prevState.limit !== limit || prevState.page !== page) {
            this.fetchQuestionsToRender({
                limit,
                page,
            });
        }
    }

    fetchQuestionsToRender({ limit, page }) {
        this.props.fetchQuestions({
            limit,
            page,
        });
    }

    onChangePage(newPage) {
        this.setState({ page: newPage });
    }

    onChangeRowsPerPage(newLimit) {
        this.setState({ limit: newLimit, page: 0 });
    }

    handleQuestionsAddeds({ questionId, checked }) {
        const { questionsAddeds } = this.state;
        if (checked) {
            if (!questionsAddeds.includes(questionId)) {
                this.setState({
                    questionsAddeds: [...questionsAddeds, questionId],
                });
            }
        } else {
            const newQuestions = questionsAddeds.filter(
                question => question !== questionId,
            );
            this.setState({
                questionsAddeds: [...newQuestions],
            });
        }
    }

    render() {
        const { total, limit, page, questions, questionsAddeds } = this.state;
        const { checkDisableQuestionFn } = this.props;

        return (
            <SelectionQuestionPresentation
                onChangePage={this.onChangePage.bind(this)}
                onChangeRowsPerPage={this.onChangeRowsPerPage.bind(this)}
                total={total}
                limit={limit}
                page={page}
                questions={questions}
                questionsAddeds={questionsAddeds}
                handleQuestionsAddeds={this.handleQuestionsAddeds.bind(this)}
                checkDisableQuestionFn={checkDisableQuestionFn}
            />
        );
    }
}

// eslint-disable-next-line no-unused-vars
const mapStateToProps = ({ questionsDatabase }) => ({
    questions: questionsDatabase.questions,
    total: questionsDatabase.total,
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchQuestions,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(SelectionQuestions);



// WEBPACK FOOTER //
// ./src/components/selection-questions/selection-questions.js